import React from 'react';
import Paginator from '../../../../components/Paginator/index';
import { EPillar } from "../../../../types/challenges";
import CustomHeader from './CustomHeader';
import CustomTable from './CustomTable';

interface ShowProps {
  dataCards: any[];
  selectedCategory: EPillar | null;
  onCardClick: (pillar: EPillar) => void;
  searchValue: string;
  onSearchChange: (v: string) => void;
  onOpenFilter: () => void;
  challenges: any[];
  page: number;
  totalPages: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  sortBy: string;
  sortDir: 'asc' | 'desc';
  onSort: (key: string) => void;
  challengeTotals: Record<string, number>;
  uniqueTypes: string[];
  filterStatus: string;
  filterType: string;
  modalStatus: string;
  modalType: string;
  setModalStatus: (v: string) => void;
  setModalType: (v: string) => void;
  setOpenFilter: (v: boolean) => void;
  setFilterStatus: (v: string) => void;
  setFilterType: (v: string) => void;
  onCreateEdit: () => void;
  onEditChallenge: (challenge: any) => void;
  onToggleStatus: (challengeId: string, currentStatus: boolean) => Promise<boolean>;
}

const Show: React.FC<ShowProps> = (props) => {
  return (
    <div className="padding-50">
      <CustomHeader dataCards={props.dataCards} onCardClick={props.onCardClick} selectedCategory={props.selectedCategory} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <CustomTable
              data={props.challenges}
              page={props.page}
              totalPages={props.totalPages}
              onPageChange={props.onPageChange}
              sortBy={props.sortBy}
              sortDir={props.sortDir}
              onSort={props.onSort}
              searchValue={props.searchValue}
              onSearchChange={props.onSearchChange}
              onEditChallenge={props.onEditChallenge}
              onCreateEdit={props.onCreateEdit}
              onToggleStatus={props.onToggleStatus}
            />
            <Paginator
              handlePage={params => props.onPageChange(params.page)}
              page={props.page}
              pages={props.totalPages}
              pageSize={props.pageSize}
              disabled={props.challenges.length == 0}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Show; 